import browser from './browser';

export default () =>
  window.CONFIG.supportedBrowsers?.some(({ name, version }) => name === browser.name && version <= browser.version);
